<div class="relative flex h-full">
  <!-- Toggle overlay: positioned absolutely over the editor/preview header (top-left) -->
  @if (showPreviewToggle()) {
    <div class="absolute left-3 top-2 z-[60]">
      <mat-button-toggle-group
        class="custom-toggle-group size-xs"
        hideSingleSelectionIndicator
        [value]="previewing() ? 'preview' : 'editor'"
        (change)="previewing.set($event.value === 'preview')"
      >
        <mat-button-toggle value="editor">
          <dojo-icon icon="pen-to-square" [size]="12" class="mr-1" />
          Editor
        </mat-button-toggle>
        <mat-button-toggle value="preview">
          <dojo-icon icon="eye" [size]="12" class="mr-1" />
          Preview
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }

  <div #scrollableContainerRef class="h-full flex-1 overflow-auto">
    <div class="flex min-h-full gap-8">
      <!-- Editor: always mounted, hidden via CSS when previewing so the editor instance stays alive -->
      <dojo-tiptap-editor-wrapper
        #editorWrapper
        class="min-h-full flex-1"
        [class.hidden]="previewing()"
        [valueControl]="editorControl"
        [outputFormat]="TiptapEditorOutputFormat.Json"
        [editorOptions]="editorOptions()"
        [editable]="editable()"
        [slashMenuItems]="slashMenuItems"
        [scrollableParent]="scrollableContainer()"
        [contentPadding]="contentPadding()"
        [smartLinkConfig]="reactSmartLinkConfig()"
        [collabConfig]="collabConfig()"
      />

      @if (collabConfig(); as config) {
        @if (!previewing() && state.hasThreads && editor(); as editor) {
          @if (collabProvider(); as provider) {
            <div class="relative shrink-0 pt-2" style="width: 280px">
              <dojo-tiptap-threads-panel [editor]="editor" [provider]="provider" [user]="config.user" />
            </div>
          }
        }
      }
    </div>

    <!-- Preview mode -->
    @if (previewing()) {
      <!-- Sticky header background for the toggle buttons -->
      <div class="study-notes-preview-header sticky top-0 z-50 h-12"></div>

      <div
        #previewContentRef
        class="study-notes-preview"
        [style.padding]="contentPadding()"
        style="max-width: 768px; margin: 0 auto"
      >
        <dojo-content-blocks-renderer [blocks]="liveBlocks()" [defaultFormulaBookletUrl]="formulaBookletUrl()" />
      </div>
    }
  </div>

  @if (showTableOfContents()) {
    <div class="shrink-0 overflow-y-auto border-l border-neutral-200 pl-5 pt-4" style="width: 240px">
      <div class="text-secondary mb-1 text-sm font-medium">{{ 'learn_hub.on_this_page' | transloco }}</div>
      @if (!previewing() && editor(); as editor) {
        <dojo-tiptap-table-of-contents
          [tableOfContentData]="tableOfContentsData()"
          [editor]="editor"
          [scrollableParent]="scrollableContainer()"
        />
      } @else if (previewing()) {
        <dojo-content-block-toc
          [blocks]="liveBlocks()"
          [scrollableParent]="scrollableContainer()"
          [queryRoot]="previewContent()"
        />
      }
    </div>
  }
</div>
